import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
  People as SubscribersIcon,
  Article as BlogsIcon,
  Campaign as CampaignsIcon
} from '@mui/icons-material';

const MarketingLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    if (location.pathname.includes('/marketing/blogs')) return 1;
    if (location.pathname.includes('/marketing/campaigns')) return 2;
    return 0; // subscribers
  };

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/utilities/marketing/subscribers');
        break;
      case 1:
        navigate('/utilities/marketing/blogs');
        break;
      case 2:
        navigate('/utilities/marketing/campaigns');
        break;
    }
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'rgba(255, 255, 255, 0.2)', mb: 3 }}>
        <Tabs 
          value={getCurrentTab()} 
          onChange={handleTabChange}
          sx={{
            '& .MuiTab-root': {
              color: 'rgba(255, 255, 255, 0.7)',
              '&.Mui-selected': {
                color: 'white'
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: 'white'
            }
          }}
        >
          <Tab icon={<SubscribersIcon />} label="Subscribers" iconPosition="start" />
          <Tab icon={<BlogsIcon />} label="Blogs" iconPosition="start" />
          <Tab icon={<CampaignsIcon />} label="Campaigns" iconPosition="start" />
        </Tabs>
      </Box>
      <Outlet />
    </Box>
  );
};

export default MarketingLayout;
